module.exports = __webpack_public_path__ + "img/Screen02.89cc382d.svg";